import {
    faCircle,
    faEllipsisVertical,
    faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import {
    Button,
    Card,
    Col,
    Container,
    Dropdown,
    Form,
    Image,
    Row,
    Table,
} from "react-bootstrap";
import {
    AssignImg,
    Build_Img,
    Delete_2,
    Edit_2,
    Eye_2,
    Filters,
    Man,
} from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";

const Department = () => {
    const breadcrumData = ["Dashboard"];
    const breadcrumItem = ["Department List"];

    return (
        <div className="role_list_screen Department_list_area">
            <WithoutImageHeader
                header={Constants.DEPARTMENT_LIST}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                lefticon={"menu"}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="role_list_details">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <p>Total Department:250</p>
                                </div>
                                <div className="right_area">
                                    <a
                                        className="btn btn-primary"
                                        href="/add-departement"
                                    >
                                        Add Department
                                    </a>
                                </div>
                            </div>
                            <div className="search_section">
                                <div className="search_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                            />
                                            <a>
                                                <div className="icon">
                                                    <FontAwesomeIcon
                                                        icon={faSearch}
                                                    />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="list_detail">
                                <div className="list_data">
                                    <Table responsive>
                                        <tr>
                                            <th className="role_text">
                                                Hospital Name
                                            </th>
                                            <th>Department Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className="profile_info">
                                                    <div className="left_area">
                                                        <div className="img_profile">
                                                            <Image
                                                                src={Build_Img}
                                                                alt="..."
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <p>IVY Hospital</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="label">
                                                    <p>{"item.title"}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="switch_area">
                                                    <Form>
                                                        <Form.Check
                                                            type="switch"
                                                            id="custom-switch"
                                                            label="Active"
                                                            checked={
                                                                parseInt(
                                                                    "item.status"
                                                                ) === 1
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                    </Form>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="icon">
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="none"
                                                            id="dropdown-basic"
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEllipsisVertical
                                                                }
                                                                className="ellipsis_icon"
                                                            />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item>
                                                                Edit
                                                                <Image
                                                                    src={Edit_2}
                                                                    alt="..."
                                                                    className="image_area"
                                                                />
                                                            </Dropdown.Item>
                                                            <Dropdown.Item>
                                                                Delete
                                                                <Image
                                                                    src={
                                                                        Delete_2
                                                                    }
                                                                    alt="..."
                                                                    className="image_area delete_icon "
                                                                />
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Department;
